import { render } from "./WhatMakesUsDifferent.vue?vue&type=template&id=9331ea8e"
import script from "./WhatMakesUsDifferent.vue?vue&type=script&lang=js"
export * from "./WhatMakesUsDifferent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__